import React from 'react';
import { motion } from 'framer-motion';
import { WhatsNewFeature } from '../../core/interface/whats-new.interface';

interface FeatureCardProps {
    feature: WhatsNewFeature;
    accentColor: string;
    /** framer-motion variants applied by the parent's staggered container. */
    variants?: any;
}

/** Small icon + short title + one-line description, styled as a soft, bordered card. */
const FeatureCard: React.FC<FeatureCardProps> = ({ feature, accentColor, variants }) => {
    const Icon = feature.icon;
    return (
        <motion.div
            variants={variants}
            className='flex items-start gap-3 rounded-xl border border-gray-200 bg-white p-3 shadow-sm transition-colors hover:border-gray-300 hover:bg-gray-50'
        >
            <div
                className='flex h-8 w-8 shrink-0 items-center justify-center rounded-lg'
                style={{ backgroundColor: `${accentColor}14` }}
            >
                <Icon size={16} color={accentColor} strokeWidth={2} />
            </div>
            <div className='min-w-0 text-left'>
                <p className='text-sm font-semibold text-gray-900'>{feature.title}</p>
                <p className='text-[13px] leading-5 text-gray-500'>{feature.description}</p>
            </div>
        </motion.div>
    );
};

export default FeatureCard;
